import {
  EMPLOYEE_ALL,
  EMPLOYEE_GET,
  EMPLOYEE_DEL,
  EMPLOYEE_PUT,
  EMPLOYEE_POST,
  EMPLOYEE_LOADING,
  EMPLOYEE_ERROR,
  EMPLOYEE_RESET,
  EMPLOYEE_PENDING_COUNT,
} from '../../actions/types';

const initialState = {
  employee: null,
  isLoading: true,
  isCompleted: true,
  pendingCount: 0,
  lastUpdatedAt: null,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case EMPLOYEE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case EMPLOYEE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case EMPLOYEE_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case EMPLOYEE_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        lastUpdatedAt: Date.now(),
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case EMPLOYEE_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    case EMPLOYEE_RESET:
      return { employee: null, isLoading: true, isCompleted: true };
    case EMPLOYEE_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case EMPLOYEE_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    case EMPLOYEE_PENDING_COUNT:
      return { ...state, pendingCount: action.payload };
    case 'EMPLOYEE_UPDATE_LOCAL':
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    default:
      return state;
  }
}
